import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ClientViewModel } from '../view-models/client.view-model';
import { PageViewModel } from '@components/ui/table-template/models/page-view-model';

@Component({
    selector: 'app-tile',
    templateUrl: './tile.component.html',
    styleUrls: ['./tile.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, AngularSvgIconModule]
})
export class TileComponent {
  public readonly currentPage = input<PageViewModel<ClientViewModel>>();
}
